module.exports = "<ul class=\"accordion\">\n    <li class=\"accordion-container\">\n        <ng-content></ng-content>\n    </li>\n</ul>"